// Port of webapp/src/components/sidebar/sidebarSettingsMenu.tsx +
// globalHeaderSettingsMenu.tsx — theme switch, sign out, and (clone-only) a
// reset for the demo dataset.

import {ReactElement} from 'react'
import {useNavigate} from 'react-router-dom'
import {Icon} from '../common/icons'
import {ButtonWithMenu, Menu, MenuItem, MenuSeparator} from '../common/menu'
import {useUsers} from '../../store/users'
import {useBoards} from '../../store/boards'
import {useCards} from '../../store/cards'
import {useViews} from '../../store/views'
import {useContents} from '../../store/contents'
import {useComments} from '../../store/comments'
import {useSidebar} from '../../store/sidebar'
import {onLoggedIn} from '../../store/initialLoad'
import client from '../../api/client'
import {getActiveThemeName, setTheme, themeChoices} from '../../common/theme'

export default function SidebarSettingsMenu(): ReactElement {
    const navigate = useNavigate()
    const logout = useUsers((state) => state.logout)

    const signOut = async (): Promise<void> => {
        await logout()
        navigate('/login')
    }

    const resetDemoData = async (): Promise<void> => {
        await client.resetMockDatabase()

        // reload the caches the same way a fresh boot would
        useBoards.setState({boards: {}})
        useCards.setState({cards: {}})
        useViews.setState({views: {}})
        useContents.setState({contents: {}, loadedForCardIds: {}})
        useComments.setState({comments: {}})
        useSidebar.setState({categories: []})

        const next = await onLoggedIn()
        navigate(next ? `/team/${next}` : '/login')
    }

    return (
        <ButtonWithMenu
            button={
                <span className='IconButton text-sidebar-fg/70 hover:text-sidebar-fg' aria-label='设置'>
                    <Icon name='settings' size={16}/>
                </span>
            }
        >
            <Menu ariaLabel='设置菜单'>
                <div className='px-3 py-1 text-xxs uppercase opacity-60'>主题</div>
                {themeChoices.map((choice) => (
                    <MenuItem
                        key={choice.name}
                        checked={getActiveThemeName() === choice.name}
                        onClick={() => {
                            setTheme(choice.theme)
                            navigate(0)
                        }}
                    >
                        {choice.label}
                    </MenuItem>
                ))}
                <MenuSeparator/>
                <MenuItem icon='duplicate' onClick={() => void resetDemoData()}>
                    重置演示数据
                </MenuItem>
                <MenuSeparator/>
                <MenuItem icon='logout' onClick={() => void signOut()}>
                    退出登录
                </MenuItem>
            </Menu>
        </ButtonWithMenu>
    )
}
